import { render, staticRenderFns } from "./primarymenu.vue?vue&type=template&id=23612e24&scoped=true"
import script from "./primarymenu.vue?vue&type=script&lang=js"
export * from "./primarymenu.vue?vue&type=script&lang=js"
import style0 from "./primarymenu.vue?vue&type=style&index=0&id=23612e24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23612e24",
  null
  
)

export default component.exports